

export function childNodes(node) {
    return node?.content?.content ?? [];
}
